import React, {useCallback} from "react";
import {Link} from "react-router-dom";

import Icon from "@ant-design/icons";

import {ReactComponent as CloseIcon} from "assets/icons/close.svg";
import {RouteUrls} from "routing/routing.constants";
import {PageType} from "shared/constants/PageType";
import {useConfigCenter} from "core/context/ConfigCenter";

import "./MenuPanel.scss";

interface MenuPanelProps {
  visible: boolean;
  onClose: () => void;
}

export const MenuPanel: React.FC<MenuPanelProps> = React.memo(({ onClose, visible }) => {
  const [, { changePage }] = useConfigCenter();
  const scrollCb = useCallback(() => {
    document.getElementById("the-game")?.scrollIntoView({ behavior: "smooth" });
  }, []);
  const linkTabIndex = visible ? undefined : -1;

  return (
    <section className={["menu-panel", visible && "open"].filter(Boolean).join(" ")} aria-hidden={!visible}>
      <Icon className="close-button" component={CloseIcon} onClick={onClose} />
      <div className="menu-panel__list">
        <Link className="menu-panel__list_item" to={`${RouteUrls.ROOT_URL}#the-game`} tabIndex={linkTabIndex} onClick={(event) => changePage(PageType.MAIN, scrollCb, event)}>
          the game
        </Link>
        <Link className="menu-panel__list_item" to={RouteUrls.OUR_PROCESS_URL} tabIndex={linkTabIndex} onClick={(event) => changePage(PageType.OUR_PROCESS, undefined, event)}>
          our process
        </Link>
        <Link className="menu-panel__list_item" to={`${RouteUrls.FOR_INFLUENCERS_URL}/`} tabIndex={linkTabIndex} onClick={(event) => changePage(PageType.FOR_INFLUENCERS, undefined, event)}>
          for influencers
        </Link>
        <Link className="menu-panel__list_item" to={`${RouteUrls.WAX_WALLET_URL}/`} tabIndex={linkTabIndex} onClick={(event) => changePage(PageType.WAX_WALLET, undefined, event)}>
          free wax wallet
        </Link>
        <Link className="menu-panel__list_item" to={RouteUrls.CONTACT_US_URL} tabIndex={linkTabIndex} onClick={(event) => changePage(PageType.CONTACT_US, undefined, event)}>
          contact us
        </Link>
      </div>
    </section>
  );
});
